import React from 'react';
import {inject} from 'mobx-react';
import {withRouter} from 'react-router-dom';

@withRouter
@inject('userStore')
export default class Logout extends React.Component {

  componentWillMount(){
    this.props.userStore.logout();
    this.props.history.push('/')
  }

  render(){
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/modules/profile/components/Logout.js